import { render, staticRenderFns } from "./FarmView.vue?vue&type=template&id=3a9d90fa&scoped=true&"
import script from "./FarmView.vue?vue&type=script&lang=js&"
export * from "./FarmView.vue?vue&type=script&lang=js&"
import style0 from "./FarmView.vue?vue&type=style&index=0&id=3a9d90fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9d90fa",
  null
  
)

export default component.exports